const apiVersion = 'v1';

const apiEndpoints = {
  LEAD_SOURCES: `${apiVersion}/lead-sources/`,
  TITLE_COMPANIES: `${apiVersion}/title-companies/`,
  COMPANIES_PROFILE: `${apiVersion}/company-profile/`,
  LENDERS: `${apiVersion}/lenders/`,
  USERS: `${apiVersion}/users/`,
  AGENTS: `${apiVersion}/agents/`,
  AUTH: `${apiVersion}/auth/`,
  GOOGLE: `${apiVersion}/auth/`,
  USER_DATA: `${apiVersion}/users/data/`,
  CLOSING_EVENTS: `${apiVersion}/closing-events/`,
  CLOSING_EVENTS_EMPLOYEE_COMPENSATION: `${apiVersion}/closing-events/:eventId/employee-compensation/:userId/:userRole`,
  CLOSING_EVENTS_SEARCH: `${apiVersion}/closing-events/search`,
  CLOSING_EVENTS_PAY: `${apiVersion}/closing-events/pay/`,
  CLOSING_EVENTS_PAYSTUBS: `${apiVersion}/closing-events/paystubs`,
  CLOSING_EVENTS_PAYSTUB_PDF: `${apiVersion}/closing-events/paystub-pdf`,
  CLOSING_EVENTS_OUTSTANDINGS: `${apiVersion}/closing-events/outstandings`,
  ANALYTICS: `${apiVersion}/analytics/`,
  SALES_TARGET: `${apiVersion}/sales-target/`,
  CLOSING_EVENTS_FOLDERS: `${apiVersion}/closing-events/folders/`,
  CLOSING_EVENTS_OFFICER: `${apiVersion}/closing-events/officer/`,
  CLOSING_EVENTS_PRODUCTION_HISTORY: `${apiVersion}/closing-events/production-history`,
  ENCOMPASS_LOGIN: `${apiVersion}/encompass-login/`,
  TEMPLATES: `${apiVersion}/template/`,
  FORM_GENERATOR: `${apiVersion}/form-generator/`,
  POSITIONS: `${apiVersion}/positions/`,
  // Seniority on a profile — Junior, Senior. Nothing to do with `TITLE_COMPANIES`
  // above, which are escrow firms.
  TITLES: `${apiVersion}/titles/`,
  COMPANY_DEPARTMENTS: `${apiVersion}/company-departments/`,
  // The types a directory contact can be filed under.
  CONTACT_TYPES: `${apiVersion}/contact-types/`,
  ROLES: `${apiVersion}/roles/`,
  HOME_HERO: `${apiVersion}/home-hero/`
};

export default apiEndpoints;
